import {
  SET_AUTH_STATE,
  ENQUEUE_SNACKBAR,
  CLOSE_SNACKBAR,
  REMOVE_SNACKBAR,
  CLEAR_SNACKBAR,
  DASHBOARD_SELECTED,
  SECURITY_GROUP_SELECTED,
  USER_TYPE_SELECTED,
  SET_DARK_MODE,
} from '../action-constants';

const initialState = {
  authState: null,
  dashboard: null,
  securityGroup: null,
  notifications: [],
  userType: {
    type: '',
    perms: {
      access: 'can-raise',
      service: 'can-raise',
      change: 'can-raise',
      security: 'none',
      incidents: 'none',
      keys: 'none',
      notifications: 'none',
      documents: 'none',
      settings: 'none',
    },
  },
};

const setAuthState = (state, action) => {
  const { authState } = action;
  return {
    ...state,
    authState,
  };
};

const setDashboard = (state, action) => {
  const { dashboard } = action;
  return {
    ...state,
    dashboard,
  };
};

const setUserType = (state, action) => {
  const { userType } = action;
  // Replace perms object to ensure new permissions overwrite old ones
  return {
    ...state,
    userType: {
      ...state.userType,
      ...userType,
      perms: { ...userType.perms },
    },
  };
};

const setSecurityGroup = (state, action) => {
  const { securityGroup } = action;
  return {
    ...state,
    securityGroup,
  };
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_AUTH_STATE: {
      return setAuthState(state, action);
    }
    case DASHBOARD_SELECTED: {
      return setDashboard(state, action);
    }
    case USER_TYPE_SELECTED: {
      return setUserType(state, action);
    }
    case SECURITY_GROUP_SELECTED: {
      return setSecurityGroup(state, action);
    }
    case ENQUEUE_SNACKBAR:
      return {
        ...state,
        notifications: [
          ...state.notifications,
          {
            key: action.key,
            ...action.notification,
          },
        ],
      };

    case CLOSE_SNACKBAR:
      return {
        ...state,
        notifications: state.notifications.map((notification) =>
          action.dismissAll || notification.key === action.key
            ? { ...notification, dismissed: true }
            : { ...notification }
        ),
      };

    case REMOVE_SNACKBAR:
      return {
        ...state,
        notifications: state.notifications.filter(
          (notification) => notification.key !== action.key
        ),
      };

    case CLEAR_SNACKBAR:
      return {
        ...state,
        notifications: [],
      };

    case SET_DARK_MODE:
      return {
        ...state,
        darkMode: action.darkMode,
      };

    default:
      return state;
  }
};
